import React, { useCallback } from 'react';
import * as Styles from './BannerDomainRegisterHandler.styles';
import {
  Button,
  Skeleton,
} from 'gatorcomponents';
import bannerDomainRegisterHandlerImg from '@/media/domains/banner-resgate-de-dominio-gratuito.png';
import bannerDomainRegisterHandlerImgMobile from '@/media/domains/banner-resgate-de-dominio-gratuito-mobile.png';
import { locale } from '@/utils/locale';
import { useHistory } from 'react-router';
import { useResize } from '@/hooks/useResize';

const BannerDomainRegisterHandler = ({
  locales,
  loaded,
  redeemAvailability,
}) => {
  const history = useHistory();
  const windowRect = useResize();
  const reedemAvailabilityDomainsLength = redeemAvailability && redeemAvailability.domains.length;
  const { width } = windowRect;
  const isMobile = width <= 600;

  const handleClick = useCallback(() => {
    history.push(`${locale('routes.domains')}${locale('routes.registerDomain')}`);
  }, [history]);

  if (!loaded) {
    return (
      <Styles.SkeletonList>
        <Skeleton width="100%" height="150px" />
        <Skeleton width="100%" height="150px" />
      </Styles.SkeletonList>
    );
  }

  return (
    <Styles.Wrapper>
      <Styles.Image src={isMobile ? bannerDomainRegisterHandlerImgMobile : bannerDomainRegisterHandlerImg} />
      <Styles.Content>
        <Styles.Title>{locales.bannerDomainRegisterHandler.title(reedemAvailabilityDomainsLength)}</Styles.Title>
        <Styles.Description>
          {locales.bannerDomainRegisterHandler.description(reedemAvailabilityDomainsLength)}
        </Styles.Description>
        <Styles.ButtonWrapper>
          <Button
            iconLeft={null}
            iconRight={null}
            label={locales.bannerDomainRegisterHandler.button}
            title={locales.bannerDomainRegisterHandler.button}
            size="medium2"
            variant="primary"
            width="fit-content"
            onClick={handleClick}
          />
        </Styles.ButtonWrapper>
      </Styles.Content>
    </Styles.Wrapper>
  );
};

export default BannerDomainRegisterHandler;
